import { render, staticRenderFns } from "./pi-details-item.vue?vue&type=template&id=e38794f2&"
import script from "./pi-details-item.vue?vue&type=script&lang=ts&"
export * from "./pi-details-item.vue?vue&type=script&lang=ts&"
import style0 from "./pi-details-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports